import { Action } from "redux";
import { Saga, SagaIterator } from "redux-saga";
import { call, cancelled } from "redux-saga/effects";

export interface OnCompleteResult<T = any> {
    error?: any;
    cancelled?: boolean;
    data?: T;
}

export type OnComplete<T = any> = (result: OnCompleteResult<T>) => void;

export interface ActionWithCallback extends Action {
    onComplete: OnComplete;
}

function onComplete(action: Action, result: OnCompleteResult) {
    if ((action as ActionWithCallback).onComplete) {
        (action as ActionWithCallback).onComplete(result);
    }
}

export function withCallback(saga: Saga): Saga {
    return function* (action: Action): SagaIterator {
        let error;
        let data;
        try {
            data = yield call(saga, action);
        } catch (err) {
            error = err;
        } finally {
            if (yield cancelled()) {
                // eslint-disable-next-line no-unsafe-finally
                return onComplete(action, { cancelled: true });
            }
        }

        onComplete(action, {
            error,
            data,
        });
    };
}
